import { useState, useCallback } from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import { InventoryInput } from 'domain/entities/Inventory'
import { GraphQLInventoryRepository } from 'infrastructure/graphql/InventoryRepositoryImpl'

export function useUpdateInventory() {
  const { getIdTokenClaims } = useAuth0()

  const [updating, setUpdating] = useState(false)
  const [error, setError] = useState<Error | null>(null)

  const updateInventory = useCallback(
    async (inventoryId: string, input: InventoryInput) => {
      setUpdating(true)
      setError(null)
      try {
        const getToken = async () => (await getIdTokenClaims())?.__raw ?? ''
        const repo = new GraphQLInventoryRepository(getToken)
        const inventory = {
          ...input,
          id: inventoryId,
        }
        const updated = await repo.update(inventory)
        return updated
      } catch (err: any) {
        setError(err)
        throw err
      } finally {
        setUpdating(false)
      }
    },
    [getIdTokenClaims]
  )

  return { updateInventory, updating, error }
}
